import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../common/html/checkbox'
import { Radio } from '../../../common/html/radio'
import { TIME_PERIOD } from '../constant'
import { changeFilter, selectFilter } from '../store/slice'
import { RadioDateRange } from './RadioDateRange'

export const Option = ({ type, filterType, value, label, isI18n }) => {
  const dispatch = useDispatch()
  const filterData = useSelector(selectFilter(filterType))

  const onClickRadio = (val) => {
    const payload = { [filterType]: val, page: 1 }
    if (filterType === 'timePeriod') {
      payload.startDate = TIME_PERIOD[value].startDate
      payload.endDate = TIME_PERIOD[value].endDate
    }
    dispatch(changeFilter(payload))
  }

  const onClickCheckbox = (isCheck) => {
    dispatch(
      changeFilter({
        [filterType]: isCheck
          ? [...filterData, value]
          : filterData.filter((i) => i !== value),
        page: 1,
      }),
    )
  }

  const renderOption = () => {
    switch (type) {
      case 'radio':
        if (filterType === 'timePeriod' && value === TIME_PERIOD.CUSTOM.key) {
          return <RadioDateRange value={value} activeValue={filterData} />
        }
        return (
          <Radio
            title={label}
            value={value}
            activeValue={filterData}
            isI18n={isI18n}
            onChange={onClickRadio}
            isCheckOnClickText
            appendStyle={{ marginTop: 8 }}
          />
        )
      case 'checkbox':
        const checked = filterData && filterData.includes(value)
        return (
          <Checkbox
            title={label}
            value={value}
            checked={checked}
            isI18n={isI18n}
            onChange={onClickCheckbox}
            isCheckOnClickText
            appendStyle={{ marginTop: 8 }}
          />
        )
      default:
        break
    }
  }

  return <>{renderOption()}</>
}
